// ─── Update this file to customize the navbar for your project ───────────────
import FeatureFlags from "@config/feature-flags.json";
import RoutesConst from "@consts/RoutesConst";

export const LOGO_TEXT = "Beats By Zer0";

export const SCROLL_THRESHOLD = 500;

export interface NavItem {
  label: string;
  href: string;
}

export interface SocialItem {
  href: string;
  /** FA icon class without size modifier, e.g. "fa-brands fa-youtube" */
  iconClass: string;
  label: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: "Home", href: RoutesConst.DEFAULT },
  ...(FeatureFlags.PROJECTS_PAGE
    ? [{ label: "Projects", href: RoutesConst.PROJECTS }]
    : []),
  { label: "Blog", href: RoutesConst.BLOG.DEFAULT },
  { label: "FAQ", href: RoutesConst.FAQ },
];

export const SOCIAL_ITEMS: SocialItem[] = [
  {
    href: "https://www.youtube.com/channel/UCqiRdTiMJ1jWPeVELNkkQ9Q?view_as=subscriber?sub_confirmation=1",
    iconClass: "fa-brands fa-youtube",
    label: "YouTube",
  },
  {
    href: "https://www.tiktok.com/@beatsbyzer0",
    iconClass: "fa-brands fa-tiktok",
    label: "TikTok",
  },
  {
    href: "https://www.twitch.tv/beatsbyzer0",
    iconClass: "fa-brands fa-twitch",
    label: "Twitch",
  },
  {
    href: "https://open.spotify.com/artist/34dd7Gv3nr4D0JqhJznlSg",
    iconClass: "fa-brands fa-spotify",
    label: "Spotify",
  },
  {
    href: "https://music.apple.com/us/artist/zer0-tolerance/1581294675",
    iconClass: "fa-brands fa-apple",
    label: "Apple Music",
  },
  {
    href: "https://audius.co/beatsbyzer0",
    iconClass: "fa-solid fa-music",
    label: "Audius",
  },
  {
    href: "https://www.twitter.com/beatsbyzer0",
    iconClass: "fa-brands fa-twitter",
    label: "Twitter",
  },
  {
    href: "https://www.instagram.com/beatsbyzer0/",
    iconClass: "fa-brands fa-instagram",
    label: "Instagram",
  },
  {
    href: "https://www.facebook.com/beatsbyzer0/",
    iconClass: "fa-brands fa-facebook-square",
    label: "Facebook",
  },
  {
    href: "mailto:ztinstrumentals@gmail.com",
    iconClass: "fa-regular fa-envelope",
    label: "Email",
  },
];
